import { IArticle, IArticleBackend, createArticle } from "./article";

export interface IFolderBackend {
  id: number;
  name: string;
  articles: IArticleBackend[];
  updated_at: string;
  created_at: string;
  sub_folder: IFolderBackend[];
  parent_folder: number | null;
}

export interface IFolder {
  id: number;
  name: string;
  articles: IArticle[];
  updatedAt: string;
  createdAt: string;
  subFolder: IFolder[] | null;
  parentFolder: number | null;
}

export const createFolder = (folder: IFolderBackend): IFolder | null => {
  if (!folder) return null;
  return Object.freeze({
    id: folder.id,
    name: folder.name,
    articles: folder.articles?.map((article) => createArticle(article)),
    createdAt: folder.updated_at,
    updatedAt: folder.created_at,
    parentFolder: folder.parent_folder,
    subFolder: folder.sub_folder?.length
      ? folder.sub_folder?.map((subFolder) => createSubFolder(subFolder))
      : [],
  });
};

export const createSubFolder = (folder: IFolderBackend): IFolder => {
  return Object.freeze({
    id: folder.id,
    name: folder.name,
    articles: folder.articles
      ? folder.articles?.map((article) => createArticle(article))
      : [],
    createdAt: folder.updated_at,
    updatedAt: folder.created_at,
    parentFolder: folder.parent_folder,
    subFolder: folder.sub_folder
      ? folder.sub_folder.map((subFolder) => createSubFolder(subFolder))
      : [],
  });
};
